import React from "react";
import { QuestionItem } from "../../../types/form";
import {
  extractSsnDigits,
  formatSsnDisplay,
} from "../../../utils/usSsnValidation";

interface SsnFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
}

const SsnFieldRenderer: React.FC<SsnFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
}) => {
  const digits = extractSsnDigits(currentValue);
  const display = formatSsnDisplay(digits);

  return (
    <div className="space-y-1">
      <input
        type="text"
        name={inputName}
        id={inputName}
        inputMode="numeric"
        autoComplete="off"
        className="border p-2 rounded-md w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 font-mono tracking-wider"
        placeholder={question.placeholder || "XXX-XX-XXXX"}
        value={display}
        disabled={readOnly}
        aria-describedby={`${inputName}-ssn-hint`}
        onChange={(e) => {
          const nextDigits = extractSsnDigits(e.target.value).slice(0, 9);
          setFormData((prev) => ({
            ...prev,
            [inputName]: nextDigits,
          }));
        }}
      />
      <p
        id={`${inputName}-ssn-hint`}
        className="text-xs text-gray-500"
      >
        Format: XXX-XX-XXXX (9 digits)
      </p>
    </div>
  );
};

export default SsnFieldRenderer;
